import { FC } from 'react';
import { Stack } from '@mui/material';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';
import LogoMark from '@/assets/f5-logo-rgb.svg';
import Lockup from '@/assets/f5-wais-light.svg';

interface Props {
  size?: 'small' | 'medium';
  align?: 'start' | 'center';
  onClick?: () => void;
}

const useStyles = createUseStyles<string, { hasClick: boolean }>({
  appLogo: {
    cursor: ({ hasClick }) => (hasClick ? 'pointer' : 'default'),
  },
  lockup: {
    display: 'block',
    width: 'auto',
    height: 'auto',
    maxWidth: 'min(250px, 100%)',
    maxHeight: 40,
  },
  logomark: {
    height: 34,
  },
});

const AppLogo: FC<Props> = ({ size = 'medium', align = 'center', onClick }) => {
  const styles = useStyles({ hasClick: !!onClick });
  const isSmall = size === 'small';
  const isStartAligned = align === 'start';

  const handleClick = () => {
    onClick?.();
  };

  return (
    <Stack
      direction="row"
      gap={2}
      justifyContent={isStartAligned ? 'flex-start' : 'center'}
      alignItems="center"
      width="100%"
    >
      <img
        src={isSmall ? LogoMark : Lockup}
        alt="F5 Workforce AI Security"
        className={classNames(styles.appLogo, isSmall ? styles.logomark : styles.lockup)}
        onClick={handleClick}
      />
    </Stack>
  );
};

export default AppLogo;
